<script setup lang="ts">
import LtDivider from '@lit-element/components/divider'
import { LtMenuItem, LtSubMenu } from '@lit-element/components/menu'
import { LtIcon } from '@lit-element/components/icon'
import type { PropType } from 'vue'

defineOptions({ name: 'LtContextmenuItem' })

// type listItem = {
//   children?: any[]
//   color?: string
//   disabled?: boolean
//   divided?: boolean
//   iconColor?: string
//   key?: string
//   label?:string
//   shortcut?:string
// }

defineProps({
  list: Array as PropType<any[]>,
  itemComp: Object,
})

function titleStyle(list?: any[]) {
  const hasIcon = list?.find((a: any) => a?.icon)
  return {
    paddingLeft: hasIcon ? '28px' : '10px',
  }
}
</script>

<template>
  <template v-for="(item, i) in list || []">
    <lt-sub-menu
      v-if="item?.children?.length"
      :key="'sub_' + i"
      :index="String(item?.key) || item?.label"
      :disabled="item.disabled"
      :teleported="false"
    >
      <template #title>
        <div
          :style="titleStyle(list)"
          style="
            width: 100%;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            position: relative;
            justify-content: space-between;
            white-space: nowrap;
          "
        >
          <LtIcon
            v-if="item.icon"
            :size="16"
            style="position: absolute; left: 2px"
          >
            <component :is="item.icon" :style="{ color: item.iconColor }" />
          </LtIcon>
          <div style="flex: 1" :style="{ color: item.color }">
            {{ item.label || item.key }}
          </div>

          <div v-if="item.shortcut" style="text-align: right; color: #adb5bd">
            {{ item.shortcut }}
          </div>
        </div>
      </template>
      <itemComp :list="item.children" :item-comp="itemComp" />
    </lt-sub-menu>

    <lt-menu-item
      v-else-if="item"
      :key="i"
      :index="String(item.key) || item.label"
      :disabled="item.disabled"
    >
      <div
        :style="titleStyle(list)"
        style="
          width: 100%;
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          position: relative;
          justify-content: space-between;
          white-space: nowrap;
        "
      >
        <LtIcon
          v-if="item.icon"
          :size="16"
          style="position: absolute; left: 2px"
        >
          <component :is="item.icon" :style="{ color: item.iconColor }" />
        </LtIcon>
        <div style="flex: 1" :style="{ color: item.color }">
          {{ item.label || item.key }}
        </div>

        <div v-if="item.shortcut" style="text-align: right; color: #adb5bd">
          {{ item.shortcut }}
        </div>
      </div>
    </lt-menu-item>

    <lt-divider
      v-if="item?.divided"
      :key="'divider_' + i"
      style="margin: 5px 0"
    />
  </template>
</template>
